import React from "react";
import ExportReports from "./exportReports";
// import CollectionSheet from "./collectionSheet";
import HistoricalReports from "./HistoricalReports";
import CollectionSheet6Months from "./collectionSheet6Months";

function Reports() {
  return (
    <>
      <ExportReports />
      <HistoricalReports />
      {/* <CollectionSheet /> */}
      <CollectionSheet6Months />
    </>
  );
}

export default Reports;